import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-6 col-md-6" }
const _hoisted_3 = { class: "col-lg-6 col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PropertiesForSaleChart = _resolveComponent("PropertiesForSaleChart")!
  const _component_PropertiesForRentChart = _resolveComponent("PropertiesForRentChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PropertiesForSaleChart)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_PropertiesForRentChart)
    ])
  ]))
}